import script from "./UpLogAlma.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpLogAlma.vue?vue&type=script&lang=ts&setup=true"

import "./UpLogAlma.vue?vue&type=style&index=0&id=5ee0374a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ee0374a"]])

export default __exports__